<template>
  <div class="home-bg">
    <register-modal @close="showRegisterModal = false" v-if="showRegisterModal"/>
    <forgot-password-modal @close="showForgotModal = false" v-if="showForgotModal"/>
    <section class="home-container">
      <div class="form-container">
        <div class="form-box">
          <div class="header-container">
            <div class="logo">
              <img src="@/assets/images/logo-healthid.png"/>
            </div>
          </div>
          <div class="body-container">
            <h1>
              Manter o controle de sua saúde nunca foi tão fácil.
            </h1>
            <p class="text-main">
              Exames de saúde por meio de coleta rápida de sangue, para você controlar e melhorar a sua saúde, de hoje e
              para o futuro.
            </p>
          </div>
          <form @submit="handleSubmit">
            <div class="input-box">
              <label class="text-main" for="email">Email</label>
              <input class="text-main" id="email" name="email" type="text" v-model="form.email"/>
            </div>
            <small class="error text-main" v-if="!!errors && !!errors.email">{{errors.email.join()}}</small>
            <div class="input-box">
              <label class="text-main" for="password">Senha</label>
              <span class="password-icon">
                <font-awesome-icon :icon="['fa', 'eye-slash']" @click="handleShowPassword" v-if="!showPassword"/>
                <font-awesome-icon :icon="['fa', 'eye']" @click="handleShowPassword" v-if="showPassword"/>
              </span>
              <input class="text-main" id="password" name="password" type="password"
                     v-model="form.password"/>
            </div>
            <small class="error text-main" v-if="errors && errors.password">{{errors.password.join()}}</small>
            <div class="form-actions">
              <div class="split">
                <div class="checkbox-label">
                  <input class="text-main" id="remember" name="remember" type="checkbox"
                         v-model="form.remember"/>
                  <label class="text-main" for="remember">Lembrar-me</label>
                </div>
                <a v-on:click.stop.prevent="showForgotModal = true">Esqueceu sua senha?</a>
              </div>
              <button class="button btn-primary" v-if="!loading">Entrar</button>
              <button class="button btn-primary" disabled v-if="loading">
                <loading/>
              </button>
              <div class="create-account">
                <span>Não possui cadastro?</span>
                <button class="button btn-primary register-button" v-on:click.stop.prevent="showRegisterModal = true">
                  Clique aqui e cadastre-se
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    import {USER_LOGIN} from '../../services/user'
    import {User} from '../../models/User'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
    import {faFacebookSquare, faGoogle} from '@fortawesome/free-brands-svg-icons'

    library.add(faEye);
    library.add(faEyeSlash);
    library.add(faGoogle);
    library.add(faFacebookSquare);

    export default {
        components: {},
        data() {
            return {
                showRegisterModal: false,
                showForgotModal: false,
                forgotPasswordUrl: "/esqueceu-senha",
                showPassword: false,
                loading: false,
                form: {
                    email: null,
                    password: null,
                    remember: false,
                },
                errors: {},
            }
        },
        methods: {
            clearErrors() {
                this.errors = [];
            },
            handleShowPassword() {
                this.showPassword = !this.showPassword;
                const password = document.getElementById('password');
                password.type = (!!this.showPassword) ? "text" : "password";
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.clearErrors();
                this.loading = true;
                try {
                    const response = await USER_LOGIN(this.form);
                    if (response.token) {
                        let user = new User();
                        user.setUser(
                            response.data.name,
                            response.data.email,
                            response.token,
                        );
                        if (this.kitNumberParameter()) {
                            window.location = "/cadastrar-kit?kit_number=" + this.kitNumberParameter();
                        } else {
                            window.location = "/kits";
                        }
                    }
                } catch (error) {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                } finally {
                    this.loading = false;
                }
            },
            kitNumberParameter() {
                let url_string = window.location.href;
                let url = new URL(url_string);
                let kit = url.searchParams.get("kit_number");
                return (!!kit) ? kit : false;
            }
        },
        mounted() {
            console.log(this.kitNumberParameter());
        }
    }
</script>

<style scoped>
  @import "./home.scss";
  @import "./responsive.css";

  .header-container {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0 0 50px 25px;
    height: auto;
    width: 50%;
    background: #fbfbfb;
    font-size: 1.5rem;
  }

  .header-container .logo {
    width: 100%;
  }

  .header-container .logo img {
    width: 150px;
  }

  .txt-blue {
    color: var(--button-blue) !important;
  }

  .header {
    display: block !important;
  }

  .logo {
    margin-bottom: 0;
  }

  .create-account {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 30px;
  }

  .create-account > span {
    margin-bottom: 10px;
  }

  .register-button {
    width: 75%;
  }

</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue